"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockLendingApi = void 0;
//@ts-ignore
const fetch_mock_1 = require("fetch-mock");
function mockLendingApi(path, method, statusCode, data, options) {
    return getMockFunctionByMethod(method)({
        path,
        status: statusCode,
        body: data,
        options,
    });
}
exports.mockLendingApi = mockLendingApi;
function getMockFunctionByMethod(method) {
    switch (method) {
        case "get":
            return mockGetLendingApiJson;
        case "post":
            return mockPostLendingApiJson;
        case "put":
            return mockPutLendingApiJson;
    }
}
function mockGetLendingApiJson({ path, status, body, options, }) {
    return fetch_mock_1.default.get(path, { status, body }, Object.assign({ overwriteRoutes: true }, options));
}
function mockPostLendingApiJson({ path, status, body, options, }) {
    return fetch_mock_1.default.post(path, { status, body }, Object.assign({ overwriteRoutes: true }, options));
}
function mockPutLendingApiJson({ path, status, body, options, }) {
    return fetch_mock_1.default.put(path, { status, body }, Object.assign({ overwriteRoutes: true }, options));
}
function mockDeleteLendingApiJson({ path, status, body, options, }) {
    return fetch_mock_1.default.delete(path, { status, body }, Object.assign({ overwriteRoutes: true }, options));
}
function mockPatchLendingApiJson({ path, status, body, options, }) {
    return fetch_mock_1.default.patch(path, { status, body }, Object.assign({ overwriteRoutes: true }, options));
}
